module.exports = __webpack_public_path__ + "static/media/portrait2.68b5bf87.png";